import { ArrowLeft } from "lucide-react";
import { contactDetails } from "../data/moselcars";

function Placeholder({ children }) {
  return <mark className="legal-placeholder" data-testid="legal-placeholder">[Bitte ergänzen: {children}]</mark>;
}

const impressumSections = [
  {
    title: "Angaben gemäß § 5 DDG",
    body: <>
      <p><strong>{contactDetails.company}</strong><br />Bahndamm 1<br />54338 Schweich-Issel<br />Deutschland</p>
      <p>Vertreten durch: <Placeholder>Vor- und Nachname der vertretungsberechtigten Person(en)</Placeholder></p>
      <p>Rechtsform: <Placeholder>z. B. Einzelunternehmen, GbR, GmbH</Placeholder></p>
    </>
  },
  {
    title: "Kontakt",
    body: <>
      <p>E-Mail: <a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a><br />Telefon: <Placeholder>Telefonnummer</Placeholder></p>
    </>
  },
  {
    title: "Registereintrag und Umsatzsteuer",
    body: <>
      <p>Handelsregister: <Placeholder>Registergericht und Registernummer, falls vorhanden</Placeholder></p>
      <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: <Placeholder>USt-IdNr.</Placeholder></p>
      <p>Aufsichtsbehörde / Gewerbeerlaubnis: <Placeholder>zuständige Behörde, sofern erforderlich</Placeholder></p>
    </>
  },
  {
    title: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
    body: <p><Placeholder>Vor- und Nachname</Placeholder><br />Bahndamm 1, 54338 Schweich-Issel</p>
  },
  {
    title: "Streitschlichtung",
    body: <>
      <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr/</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
      <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen. <Placeholder>Falls Sie teilnehmen, diesen Satz anpassen</Placeholder></p>
    </>
  },
  {
    title: "Hinweise zu Fahrzeugdaten",
    body: <p>Fahrzeugangaben, Preise und Fotos werden regelmäßig aus dem Händlerbestand übernommen. Alle Angaben ohne Gewähr; Irrtümer und Zwischenverkauf vorbehalten. Finanzierungsbeispiele sind unverbindlich und stammen aus dem jeweiligen Inserat.</p>
  },
  {
    title: "Haftung für Inhalte und Links",
    body: <>
      <p>Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
      <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.</p>
    </>
  }
];

const datenschutzSections = [
  {
    title: "1. Verantwortlicher",
    body: <p>{contactDetails.company}, Bahndamm 1, 54338 Schweich-Issel, E-Mail: <a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a>, Telefon: <Placeholder>Telefonnummer</Placeholder>. Ein Datenschutzbeauftragter ist <Placeholder>nicht bestellt / Name und Kontakt des Datenschutzbeauftragten</Placeholder>.</p>
  },
  {
    title: "2. Hosting und Server-Logfiles",
    body: <p>Beim Aufruf dieser Website verarbeitet unser Hosting-Anbieter (<Placeholder>Name und Sitz des Hosting-Anbieters</Placeholder>) automatisch Informationen wie IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, Browsertyp und Referrer-URL. Die Verarbeitung erfolgt zur Bereitstellung und Sicherheit der Website auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Logdaten werden nach <Placeholder>Speicherdauer, z. B. 7 Tagen</Placeholder> gelöscht.</p>
  },
  {
    title: "3. Kontaktformular und E-Mail-Versand",
    body: <p>Wenn Sie uns über das Kontaktformular eine Anfrage senden, verarbeiten wir Ihren Namen, Ihre E-Mail-Adresse, den Fahrzeugwunsch, einen optionalen Wunschtermin und Ihre Nachricht. Die Anfrage geht per E-Mail an unser Postfach; Sie erhalten eine Bestätigung an die angegebene Adresse. Für den Versand nutzen wir den E-Mail-Dienstleister Resend (Resend, Inc., USA) als Auftragsverarbeiter; Daten können dabei in die USA übermittelt werden (Standardvertragsklauseln). Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) sowie Ihre Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO. Die Daten löschen wir, sobald die Anfrage abschließend bearbeitet ist und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</p>
  },
  {
    title: "4. KI-Fahrzeugberater",
    body: <p>Der Fahrzeugberater beantwortet Ihre Fragen auf Basis unseres aktuellen Bestands. Ihre eingegebenen Nachrichten werden zur Beantwortung an einen KI-Dienst (OpenAI, bereitgestellt über die Plattform Emergent) übermittelt und zusammen mit einer zufälligen Sitzungskennung gespeichert, um den Gesprächsverlauf fortzuführen. Bitte geben Sie im Chat keine sensiblen personenbezogenen Daten ein. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (Bereitstellung einer Beratungsfunktion). Chatverläufe löschen wir nach <Placeholder>Speicherdauer, z. B. 30 Tagen</Placeholder>.</p>
  },
  {
    title: "5. Merkliste (lokale Speicherung)",
    body: <p>Gemerkte Fahrzeuge werden ausschließlich lokal in Ihrem Browser (localStorage) gespeichert und nicht an uns übertragen. Wenn Sie Ihre Merkliste über einen Link teilen, enthält dieser Link lediglich die Fahrzeugnummern. Sie können die Merkliste jederzeit über das Herz-Symbol oder durch Löschen der Browserdaten entfernen.</p>
  },
  {
    title: "6. Google Maps",
    body: <p>Zur Darstellung unseres Standorts binden wir Karten des Dienstes Google Maps (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland) ein. Beim Laden der Karte wird Ihre IP-Adresse an Google übermittelt; Google kann Cookies setzen und Daten in die USA übertragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Weitere Informationen: <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">https://policies.google.com/privacy</a>.</p>
  },
  {
    title: "7. Schriftarten und Bilder externer Server",
    body: <p>Diese Website lädt Schriftarten von Google Fonts (Google Ireland Limited) sowie Fahrzeugfotos von Servern der mobile.de GmbH (classistatic.de). Dabei wird Ihre IP-Adresse an den jeweiligen Anbieter übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (einheitliche Darstellung und aktuelle Fahrzeugbilder).</p>
  },
  {
    title: "8. Cookies",
    body: <p>Diese Website setzt keine Tracking- oder Werbe-Cookies. Technisch notwendige Speicherungen (Sitzungskennung des Fahrzeugberaters, Merkliste) erfolgen im Browser-Speicher und sind für die Funktion erforderlich (§ 25 Abs. 2 TDDDG).</p>
  },
  {
    title: "9. Ihre Rechte",
    body: <p>Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21 DSGVO). Erteilte Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft widerrufen. Außerdem haben Sie das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren, z. B. beim Landesbeauftragten für den Datenschutz und die Informationsfreiheit Rheinland-Pfalz.</p>
  },
  {
    title: "10. Aktualität",
    body: <p>Stand dieser Datenschutzerklärung: <Placeholder>Datum</Placeholder>. Wir passen die Erklärung an, sobald sich Rechtslage oder Funktionen der Website ändern.</p>
  }
];

export default function LegalPage({ kind, onBack }) {
  const isImpressum = kind === "impressum";
  const sections = isImpressum ? impressumSections : datenschutzSections;

  return <section className="legal-page page-shell" aria-labelledby="legal-title" data-testid={`legal-page-${kind}`}>
    <button className="detail-back-button" type="button" onClick={onBack} data-testid="legal-back-button"><ArrowLeft size={16} /> Zurück zur Startseite</button>
    <div className="legal-layout">
      <header className="legal-header">
        <span className="section-kicker">{isImpressum ? "RECHTLICHES" : "DSGVO"}</span>
        <h1 id="legal-title">{isImpressum ? <>Impressum</> : <>Datenschutz<em>erklärung</em></>}</h1>
        <p>{isImpressum ? "Anbieterkennzeichnung für den Internetauftritt von Moselcars." : "Wie wir mit Ihren Daten umgehen, wenn Sie unsere Website, das Kontaktformular oder den Fahrzeugberater nutzen."}</p>
        <p className="legal-notice" data-testid="legal-notice">Entwurf: Gelb markierte Stellen müssen noch mit Ihren Angaben ergänzt und rechtlich geprüft werden.</p>
      </header>
      <div className="legal-content">
        {sections.map((section) => <article key={section.title} className="legal-section"><h2>{section.title}</h2>{section.body}</article>)}
      </div>
    </div>
  </section>;
}
